var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"bottom-two",attrs:{"title":"电瓶车事件趋势"}},[_c('LineCharts',{attrs:{"id":"surdpcsjqs","lists":_vm.datas,"areaColor":_vm.areaColor,"colors":_vm.colors,"type":"poly"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }